var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:progress-star-four-points"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 4V2C17.66 2.5 21.33 6.19 21.85 10.85C22.4501 16.34 18.5 21.28 13 21.88V19.88C16.64 19.43 19.5 16.56 19.96 12.92C20.0896 11.8772 20.0123 10.819 19.7325 9.80614C19.4527 8.79323 18.9759 7.84542 18.3295 7.01694C17.683 6.18846 16.8796 5.49556 15.9651 4.97788C15.0506 4.46021 14.0431 4.12791 13 4ZM5.67005 4.2C7.18579 2.94859 9.04292 2.18205 11 2V4.06C9.57005 4.26 8.22005 4.84 7.10005 5.74L5.67005 4.2ZM2.05005 11C2.23575 9.04196 3.00573 7.18495 4.26005 5.67L5.69005 7.1C4.80403 8.2297 4.23764 9.5766 4.05005 11H2.05005ZM4.27005 18.33C3.02773 16.8078 2.25932 14.9546 2.06005 13H4.06005C4.24005 14.42 4.81005 15.77 5.69005 16.9L4.27005 18.33ZM5.67005 19.74L7.06005 18.37H7.10005C8.23005 19.25 9.58005 19.82 11 20V22C9.04005 21.79 7.18005 21 5.67005 19.74ZM12 17L13.56 13.58L17 12L13.56 10.44L12 7L10.43 10.44L7.00005 12L10.43 13.58L12 17Z",
    fill: "#3D4043"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.ef572ca87622dde5af9ddcf91e41edb6.svg";
export { ForwardRef as ReactComponent };